.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  font-size: 32px;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  line-height: 24px;
  font-weight: bold;
  background-color: var(--color-easil-black);
  border: solid 2px white;
  color: white;
  background-position: center;
  background-size: cover;
}

.avatar[data-has-double-border="true"] {
  border: 2px solid;
}

.light {
  background-color: white;
  color: var(--color-easil-black);
  border: solid 1px var(--color-easil-black);
}

.dark {
  background-color: var(--color-easil-black);
  color: white;
  border: none;
}

.gray {
  background-color: var(--color-easil-gray-x-light);
  color: white;
  border: solid 2px white;
}

.chars {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  user-select: none;
}
